(function () {
  'use strict';

  angular
  	.module('app.product.reviews', [])

  	.value('ReviewsConfig', {
  		nb: 3
  	})

    /* @ngInject */
    .factory('ReviewsService', ["$http", "$cacheFactory", function ($http, $cacheFactory) {
    	var reviewsCache = $cacheFactory('reviewsCache', { capacity: 100 });
      return {
      	addReview: function (url, data) {
      		return $http({
				      method: 'POST',
						  url: url,
						  headers: {
						    'Content-type': 'application/json',
						    'X-Requested-With': 'jsonHttpRequest'
						  },
				      data: data
				    })
            .then(function (response) {
              return response.data;
            })
            .catch(function (error) {
              throw error;
            });
      	},
        getReviews: function (id, page, top, sort, note) {
        	return $http({
          method: 'GET',
          url: '/Reviews/' + id + '/' + page + '/' + top + '/' + sort + '/' + note,
          headers: {
            'Content-type': 'application/json',
            'X-Requested-With': 'jsonHttpRequest'
          },
          cache: reviewsCache
        })
        		.then(function (response) {
          return response.data;
        })
            .catch(function (error) {
              throw error;
            });
        },
        setRelevance: function (id, positive) {
        	var action = positive ? 'PositiveRelevance' : 'NegativeRelevance';
        	return $http({
          method: 'GET',
          url: '/Reviews/Add/' + action + '/' + id,
          headers: {
            'Content-type': 'application/json',
            'X-Requested-With': 'jsonHttpRequest'
          },
          cache: true
        })
            .then(function (response) {
              return response.data;
            })
            .catch(function (error) {
              throw error;
            });
        },
        clearReviewsCache: function () {
        	reviewsCache.removeAll();
        }
      };
    }])

    .component('productReviews', {
      templateUrl: '/Template/Reviews/Reviews',
      bindings: {
        id: '=idProduct',
        message: '@'
      },
      /* @ngInject */
      controller: ["$scope", "$timeout", "$cacheFactory", "$cookies", "AppService", "ReviewsService", "ReviewsConfig", "toastr", function ($scope, $timeout, $cacheFactory, $cookies, AppService, ReviewsService, ReviewsConfig, toastr) {
        var ctrl = this;

        ctrl.data = {};

        ctrl.itemsPerPage = ReviewsConfig.nb;
        ctrl.maxSize = 5;

        ctrl.$onInit = function () {
          ctrl.getReviews();
        };

        ctrl.setPage = function () {
          ctrl.getReviews(ctrl.currentPage, ctrl.data.Reviews.CurrentSort, ctrl.data.Reviews.CurrentFilter);
        };

        ctrl.setShowForm = function (value) {
          ctrl.showForm = value;
          if (!value) {
            ctrl.formAdd.$hideValidation();
          }
        };

        ctrl.addReview = function () {
          ctrl.showLoader = true;
          ctrl.formAdd.data.idProduct = ctrl.id;
          ReviewsService.addReview('/Reviews/Add', ctrl.formAdd.data)
            .then(function (response) {
              if (response.status == 'OK') {
                toastr.success('', ctrl.message, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
                ctrl.formAdd.data = {
                  score: 5
                };
                $timeout(function () {
                  ctrl.formAdd.$resetValidation();
                });

                ctrl.showForm = false;
                $scope.$emit('updateNbReviews', ctrl.data.Count + 1);
                ctrl.getReviews(1, 'DateDESC', 0);
              } else {
                AppService.getTranslate()
                      .then(function (translate) {
                        toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                          allowHtml: true,
                          extraData: {
                            template: 'toast_message.tpl'
                          }
                        });
                      });
              }
              ctrl.showLoader = true;
            })
            .catch(function (error) {
              console.error(error);
            });
        };

        ctrl.getAveragePercent = function (w) {
          var n = (w * (ctrl.data.Average / 5)).toFixed(2);
          return {'clip': 'rect(0px, ' + n + 'px, 30px, 0px)'};
        };
        ctrl.getGradePercent = function (count) {
          return {'width': Math.floor(count / ctrl.data.Count * 100) + '%'};
        };

        ctrl.getReviews = function (page, sort, note) {
          page 		= page || 1;
          sort 		= sort || 'RateDESC';
          note 		= note || 0;

          ctrl.showLoader = true;
          ReviewsService.getReviews(ctrl.id, page, ReviewsConfig.nb, sort, note)
            .then(function (data) {
              ctrl.data = data;
              ctrl.showForm = ctrl.data.Count === 0 ? true : false;
              ctrl.currentPage = page;
              ctrl.showLoader = false;

              var cookies = $cookies.getObject('reviewsRelevance') || {};

              _.each(ctrl.data.Reviews.CurrentPageReviews, function (review) {
                review.Response = _.trim(review.Response);
                if (cookies[review.IDReview]) {
                  review.inactive = true;
                }
              });

            })
            .catch(function (error) {
              console.error(error);
            });
        };

        ctrl.setRelevance = function (review, positive) {

          if (review.inactive) return;

          var id = review.IDReview,
            cookies = $cookies.getObject('reviewsRelevance') || {};

          cookies[id] = true;

          var now = new Date(),
            exp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());

          $cookies.putObject('reviewsRelevance', cookies, {
            path: '/',
            expires: exp
          });

          ctrl.showLoader = true;
          ReviewsService.setRelevance(id, positive)
            .then(function (data) {
              ReviewsService.clearReviewsCache();
              ctrl.getReviews(ctrl.currentPage, ctrl.data.Reviews.CurrentSort, ctrl.data.Reviews.CurrentFilter);
            })
            .catch(function (error) {
              console.error(error);
            });

        };

        ctrl.setSort = function (sort) {
          ctrl.getReviews(0, sort, ctrl.data.Reviews.CurrentFilter);
        };

        ctrl.setFilter = function (filter, nb) {
          if (!nb) return;
          ctrl.getReviews(0, ctrl.data.Reviews.CurrentSort, filter);
        };

        ctrl.removeFilter = function () {
          ctrl.getReviews(0, ctrl.data.Reviews.CurrentSort, '');
        };

      }],
      controllerAs: 'reviewsCtrl'
    })

    .directive('reviewsLink', ["ModalService", function (ModalService) {
      return {
        restrict: 'A',
        scope: true,
        bindToController: true,
        controllerAs: 'ctrl',
        controller: function () {
          var ctrl = this;

          ctrl.openReview = function (id, designation) {
            ModalService.show(
              '/Reviews/' + id + '?view=ModalReviews',
              {
                designation: designation
              },
              'lg'
            );
          };
        }
      };
    }])

    /* @ngInject */
    .controller('formReviewsController', ["$rootScope", "$location", "AppService", "ReviewsService", "toastr", function ($rootScope, $location, AppService, ReviewsService, toastr) {
      var ctrl = this;

      ctrl.init = function (id, url, token, message) {
        ctrl.id = id;
        ctrl.url = url;
        ctrl.token = token;
        ctrl.messageOK = message;
      };

      ctrl.addReview = function () {
        $rootScope.$broadcast('showPageLoader', true);
        ctrl.formAdd.data.IDProduct = ctrl.id;
        ctrl.formAdd.data.Token = ctrl.token;
        ReviewsService.addReview('/FormReviews/Add', ctrl.formAdd.data)
          .then(function (response) {
            if (response.status === 'OK') {
              toastr.success('', ctrl.messageOK, {
                allowHtml: true,
                extraData: {
                  template: 'toast_message.tpl'
                }
              });
              $location.path(ctrl.url);
            } else {
              AppService.getTranslate()
                .then(function (translate) {
                  toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                  $rootScope.$broadcast('showPageLoader', false);
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
          })
          .catch(function (error) {
            console.error(error);
          });
      };

    }]);

})();
